import { ArrowDownMedium } from '@zoopla-eng/zds-components/icons';
import { fontGroups } from '@zoopla-eng/zds-components/themes/font-groups';
import React from 'react';
import {
    priceAlternativeStyle,
    priceReducedPercentageStyle,
    priceReducedTextStyle,
    priceTextStyle,
    priceTitleStyle,
    priceWrapperStyle
} from './price.styles.css';

type PriceProps = {
    priceTitle?: string | null;
    price?: string | null;
    priceAlternative?: string | null;
    reducedPriceDate?: string | null;
    reducedPricePercentage?: string | null;
};

const Price: React.FC<PriceProps> = ({
    priceTitle,
    price,
    priceAlternative,
    reducedPriceDate,
    reducedPricePercentage
}) => (
    <div className={priceWrapperStyle}>
        {priceTitle ? (
            <p className={`${priceTitleStyle} ${fontGroups.ladle}`}>
                {priceTitle}
            </p>
        ) : null}
        {price ? (
            <p
                className={`${priceTextStyle} ${fontGroups.mug}`}
                data-testid="listing-price"
            >
                {price}
            </p>
        ) : null}
        {priceAlternative ? (
            <p className={`${priceAlternativeStyle} ${fontGroups.ladle}`}>
                {priceAlternative}
            </p>
        ) : null}
        {reducedPricePercentage && reducedPriceDate ? (
            <p className={`${priceReducedTextStyle} ${fontGroups.fork}`}>
                <ArrowDownMedium color="functionalFailure" />
                <span className={priceReducedPercentageStyle}>
                    {reducedPricePercentage}%
                </span>
                &nbsp;
                <span>{reducedPriceDate}</span>
            </p>
        ) : null}
    </div>
);

export { Price };
